import React from "react";

import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { formatMoney, getUserProfileUrl, getUserStoreUrl, shorten } from "../../lib/common-helper";
import { ProductCategory } from '../../models/product-category';
import { PublicUserResponse } from "../../models/response/public-user.response";
import { StoreCategory } from '../../models/store-category';
import { Product } from '../../models/product';

export function ScrollProduct({ itemId, product, fireClickAction }:
  { itemId: string, product: Product, fireClickAction: any }) {
  const visibility = React.useContext(VisibilityContext);

  const visible = visibility.isItemVisible(itemId);

  // function goToStorePage()
  // {
  //   window.location.href = getUserStoreUrl(publicUserResponse.username, productCategory.id);
  //   return;
  // }

  return (
    <div
      role="button"
      onClick={() => fireClickAction()}
      className="text-center"
      style={{
        maxWidth: "200px",
        // border: "1px solid",
        display: "inline-block",
        margin: "0 6px",
        // width: "160px",
        userSelect: "none"
      }}
      tabIndex={0}
    >
      <div className="mx-auto me-2" style={{ width: "200px" }}>
        <img src={( product.productImage?.thumbnailImageFullURL ? product.productImage?.thumbnailImageFullURL : product.productImage?.imageFullURL)} width={200} height={200} className="p-1" style={{ objectFit: "cover", borderRadius: "12px" }} />
        <div>
          {
            product.primaryPrice &&
            <div className="relative">
              <div className="ps-1 pe-1" style={{
                position: "absolute", bottom: 10, right: 0,
                backgroundColor: "#FAFAFA", color: "#262626",
              }} >

                <span className="fs-8">
                  {formatMoney(product.primaryPrice, product.primaryCurrency?.code)}
                </span>
              </div>
            </div>

          }
        </div>
      </div>
      <div>
        {shorten(product.name, 30)}
      </div>


    </div>
  );
}
